import CountByDeviceWidget from './CountByDeviceWidget';
export default CountByDeviceWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/CountByDeviceWidget/index.js